import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User added or replaced the custom logo on a share link design',
  name: 'custom_logo_added',
  params: [
    {
      description: 'Type of share link the custom logo was added to',
      name: 'share_link_type',
      required: true,
      type: 'enum',
      values: ['board', 'collection'],
    },
    {
      description: 'True when the logo came from applying a brand context, false when it was picked by hand',
      name: 'from_brand_context',
      required: true,
      type: 'boolean',
    },
  ],
};

export default META;
